import { isEmpty } from 'lodash-es';
import firebase from 'firebase/app';
import 'firebase/firestore';

if (isEmpty(firebase.apps)) {
    // Initialize Firebase
    const config = {
        apiKey: 'AIzaSyCi4pMFI2odIEo2dYooqaPYBT8K03YUMAI',
        authDomain: 'sa-reviews.firebaseapp.com',
        databaseURL: 'https://sa-reviews.firebaseio.com',
        projectId: 'sa-reviews',
        storageBucket: 'sa-reviews.appspot.com',
        messagingSenderId: '279688613548'
    };
    firebase.initializeApp(config);
}

export default firebase;
